<template>
    <div class="d-inline-block">
        <a href="#" class="btn btn-primary btn-sm ml-1"  @click.prevent="handleModal"><i class="fa fa-plus-circle" aria-hidden="true"></i> Create</a>

        <Modal class="text-left" :title="title" :show="showModal" @close="showModal = false" v-if="selectOptions.length">
            <select-input :label="selectLabel" :error="error" v-model="selected">
                <option value="0">Select</option>
                <option v-for="(option, index) in selectOptions" :key="index" :value="option.id">
                    {{ option.reference }} - {{ option.name }} - {{ option.publisher_name }}
                </option>
            </select-input>
            <button class="btn btn-primary" ref="submitRef" @click="redirect">Submit</button>
            <button class="btn btn-link" @click.prevent="showModal = false">Close</button>
        </Modal>

        <Modal class="text-left" :title="title" :show="showModal" @close="showModal = false" v-if="! selectOptions.length">
            <p class="text-danger" v-html="message"></p>
            <button class="btn btn-primary" ref="submitRef" @click.prevent="showModal = false">Close</button>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal";
import SelectInput from './Inputs/SelectInput.vue';

export default {
    name: "AddModal",
    props: {
        route: { type: String, required: true },
        title: { type: String, default: 'Add item', required: false },
        selectLabel: { type: String, required: true },
        selectOptions: { type: Array, required: true },
        message: { type: String, required: true },
    },
    components: {
        Modal,
        SelectInput,
    },
    data() {
        return {
            showModal: false,
            selected: 0,
            error: '',
        };
    },
    methods: {
        handleModal() {
            this.showModal = true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.submitRef.focus();
                });
            });
        },
        redirect() {
            if(this.selected == 0) {
                this.error = 'Please make a choice first';

                return;
            }

            window.location = this.route + '?agreement='+ this.selected;
        }
    },
}
</script>